import { z } from "zod/v4";
import { venueIdSchema } from "./ids";
import { venueStatusSchema } from "./venue";

/** What is still missing before the club's venue can go live (ADR-0052). */
export const clubVenueReadinessSchema = z.object({
	courts: z.boolean(),
	hours: z.boolean(),
	payouts: z.boolean(),
	prices: z.boolean(),
});

export const clubVenueSchema = z.object({
	id: venueIdSchema,
	name: z.string(),
	readiness: clubVenueReadinessSchema,
	slug: z.string(),
	status: venueStatusSchema,
});

/**
 * The club's court-booking state: `venue: null` means "you may switch this
 * on"; 403/404 mean the caller may not see the section at all.
 */
export const clubVenueEnvelopeSchema = z.object({
	venue: clubVenueSchema.nullable(),
});

export type ClubVenueReadiness = z.infer<typeof clubVenueReadinessSchema>;
export type ClubVenue = z.infer<typeof clubVenueSchema>;
export type ClubVenueEnvelope = z.infer<typeof clubVenueEnvelopeSchema>;
